/* eslint-disable no-plusplus */
/* eslint-disable no-self-compare */
export default function calculateAge(date) {
  if (!date) {
    return 0;
  }

  const now = new Date().toLocaleString('en-US', {
    timeZone: 'America/Sao_Paulo',
  });
  const birth = new Date(date).toLocaleString('en-US', {
    timeZone: 'America/Sao_Paulo',
  });

  const today = new Date(now);
  const dateBirth = new Date(birth);

  let age = today.getFullYear() - dateBirth.getFullYear();

  const monthCurrent = today.getMonth();
  const dayCurrent = today.getDate();

  const monthBirth = dateBirth.getMonth();
  const dayBirth = dateBirth.getDate();

  if (
    monthCurrent < monthBirth ||
    (monthBirth === monthBirth && dayCurrent < dayBirth)
  ) {
    age--;
  }

  return age;
}
